// extracted by mini-css-extract-plugin
export default {"background-image":"Tasks_background-image__XBPzY App_background-image__vcgYg","page-title":"Tasks_page-title__S+a5M App_page-title__+YGNc"};